import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import store from './store.js'
import vuetify from './plugins/vuetify';
import vueHeadful from 'vue-headful';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';

Vue.use(Donut);
Vue.component('vue-headful', vueHeadful);
Vue.config.productionTip = false

Vue.prototype.$events = new Vue();

import { backend } from "./backend.js";

Vue.prototype.$backend = backend();
Vue.prototype.$backend.$store = store;
Vue.prototype.$backend.$events = Vue.prototype.$events;
Vue.prototype.$backend.$router = router;

new Vue({
  router,
  store,
  vuetify,
  data: ()=>({
    version:"DYL - v0.1",
  }),
  render: h => h(App)
}).$mount('#app')
